import createDecorator from 'final-form-calculate'
import { metaPath } from 'util/metaPath'

import { HistoricoAtendimentoFilterFormModel } from '../../model/HistoricoAtendimentoModel'

const meta = metaPath<HistoricoAtendimentoFilterFormModel>()

export const createHistoricoCalculator = () =>
  createDecorator({
    field: [meta.tipoAtendimento.absolutePath()],
    updates: {
      [meta.filtrosAvancados.subTipoAtendimento.absolutePath()]: () => undefined,
    },
  })
